<template>
    <dashboard-layout-v2
        class="app-layout"
        :user-info-to-display-in-header="displayUserFullName"
    >
        <login
            slot="login-view"
            app-name="Live Delivery"
            :use-login-slide="false"
            :image="loginImage"
        ></login>
        <template slot="sidebar-menu">
            <sidebar-link
                index="0"
                name="Home"
                i="ti-home"
                to="home"
            >
            </sidebar-link>
            <sidebar-link
                v-for="(channel, index) in sortedChannels"
                :key="channel.uid"
                :index="`${index + 1}`"
                :name="channel.name"
                :open-in-new-window="false"
                i="ti-signal"
                :href="`#/channel/${channel.uid}`"
                :path="`/channel/${channel.uid}`"
            >
            </sidebar-link>
            <sidebar-link
                v-if="$store.getters.userIsAtLeastManager"
                index="3"
                name="Users"
                i="ti-user"
                to="users"
            >
            </sidebar-link>
        </template>
    </dashboard-layout-v2>
</template>

<script>
import {DashboardLayoutV2} from 'fundation-app-vuejs';
import { mapGetters } from 'vuex';
import { Login } from 'gcmcn-common';

export default {
    name: 'App',
    components: {
        DashboardLayoutV2,
        Login,
    },

    computed: {
        ...mapGetters([
            'channels',
            'loginImage',
            'fundation', [
                'burgerMenuAllowedAndClosed',
            ]
        ]),
        sortedChannels(){
            return this.channels.sort((a,b)=>{
                return this.getChannelNumber(a.name) === this.getChannelNumber(b.name)
                ? 0
                : this.getChannelNumber(a.name) < this.getChannelNumber(b.name) ?
                    -1 : 1;
            });
        },
        displayUserFullName(){
            return (user)=>{
                if(user.first_name !== ''){
                    return `Bonjour ${user.first_name} ${user.last_name}`;
                }
                else return null;
            };
        }
    },
    mounted(){
        this.$store.dispatch('remoteGet', {url: 'asset/'}).then((res)=>{
            this.$store.commit('SET_ASSETS', res.data.results)
        });
    },
    methods: {
        getChannelNumber(name){
            let splitedName = name.split(' ');
            return parseInt(splitedName[splitedName.length-1])
        }
    }
};
</script>

<style lang="scss">
@import './main.scss';
html, body{
    margin: 0px;
    padding: 0px;
}
.dashboard-app-v2{
    .fundation-dashboard{
        .main-sidebar{
            .vuebar-element{
                .vb-content{
                    .sidebar{
                       .user-panel{
                            padding: 0 0 10px !important;
                            .image{
                                img{
                                    min-width: 100% !important;
                                }
                            }
                            .info{
                                display: none !important;
                            }
                       }
                       .sidebar-menu{
                            .sidebar-link{
                                a{
                                    .el-menu-item{
                                        background-color: #222 !important;
                                    }
                                }
                                div{
                                    .el-menu-item{
                                        background-color: #222 !important;
                                    }
                                }
                            }
                       }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue